import { planClient } from "../clients/planClient"
import type {
  PlanResponseDto,
  CreatePlanDto,
  UpdatePlanDto,
  PlanListParams,
  DeletePlanResponseDto,
} from "../types/plan.types"

/**
 * Plan Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const planService = {
  /**
   * Get plan by ID (any status, admin)
   */
  getPlanByIdAdmin: async (id: string): Promise<PlanResponseDto> => {
    try {
      const plan = await planClient.getPlanByIdAdmin(id)
      return plan
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List plans with optional filters (admin)
   * Returns array directly (not paginated)
   */
  getPlansAdmin: async (params?: PlanListParams): Promise<PlanResponseDto[]> => {
    try {
      const plans = await planClient.getPlansAdmin(params)
      return plans
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create plan
   */
  createPlan: async (data: CreatePlanDto): Promise<PlanResponseDto> => {
    try {
      const plan = await planClient.createPlan(data)
      return plan
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update plan
   */
  updatePlan: async (
    id: string,
    data: UpdatePlanDto
  ): Promise<PlanResponseDto> => {
    try {
      const plan = await planClient.updatePlan(id, data)
      return plan
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete plan
   */
  deletePlan: async (id: string): Promise<DeletePlanResponseDto> => {
    try {
      const response = await planClient.deletePlan(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default planService

